module.exports = __webpack_public_path__ + "img/14_Distal Descending Colon.f7851f9b.png";